import EditIcon from "@mui/icons-material/Edit"
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown"
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp"
import { IconButton, TableCell, TableRow, Tooltip } from "@mui/material"
import { styled } from "@mui/material/styles"
import { useState } from "react"
import { useDispatch } from "react-redux"

import { AppDispatch } from "../../../store"
import { CampaignsState } from "../../../store/actions/campaigns"
import { openDrawer } from "../../../store/campaigns/campaign-edit-slice"
//import { openDrawer } from "../../../store/bank/bank-edit-slice"

const CampaignRow = ({ row }: { row: CampaignsState }) => {
	const dispatch = useDispatch<AppDispatch>()
	const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
	const [openRow, setOpenRow] = useState<boolean>(false)

	const TableCellStyled = styled(TableCell)(() => ({
		paddingLeft: "8px",
	}))

	const handleEditCampaign = (campaign: CampaignsState) => {
		dispatch(openDrawer({ isEditMode: true, campaign: campaign }))
	}

	const base64Image = row?.campaignLogo ?? undefined
	const campaignImgSrc = base64Image && atob(base64Image)

	return (
		<TableRow
			hover
			tabIndex={-1}
			key={row.id}
			style={{
				backgroundColor: row.enabled
					? openRow
						? "#F5F7FD"
						: "#FFF"
					: "rgba(211, 211, 211, 0.1)",
			}}
		>
			<TableCellStyled>
				<IconButton
					aria-label="expand row"
					size="small"
					onClick={() => setOpenRow(!openRow)}
				>
					{openRow ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
				</IconButton>
			</TableCellStyled>
			<TableCellStyled component="td" scope="row" padding="none">
				{row.campaignName}
			</TableCellStyled>
			<TableCellStyled align="left">{row.authorizationType}</TableCellStyled>
			<TableCellStyled align="left">
				{Boolean(row.enabled) ? "Sì" : "No"}
			</TableCellStyled>
			<TableCellStyled align="left">
				{Boolean(row.deleted) ? "Sì" : "No"}
			</TableCellStyled>
			<TableCellStyled align="left">
				<img
					// alt={t("logo.campaign", { ns: "common" })}
					style={{
						width: "70px",
						maxWidth: "100%",
						height: "fit-content",
						verticalAlign: "middle",
					}}
					src={campaignImgSrc}
				/>
			</TableCellStyled>
			<TableCellStyled align="center">
				<IconButton color="primary" onClick={() => handleEditCampaign(row)}>
					<Tooltip title="Modifica configurazione corporate">
						<EditIcon />
					</Tooltip>
				</IconButton>
			</TableCellStyled>
		</TableRow>
	)
}

export default CampaignRow
